import { renderIf } from '../../../utils/render.utils';
import style from './IconButton.css';

const IconButtonType = { PRIMARY: 'primary', SECONDARY: 'secondary' };
export default function IconButton({
  className = '',
  type = IconButtonType.PRIMARY,
  text = '',
  icon,
  ...props
}) {
  return (
    <button
      className={`${className} ${style['icon-button']} ${style[type]}`}
      {...props}
    >
      <i>{icon}</i>
      {renderIf(text, <span>{text}</span>)}
    </button>
  );
}

IconButton.Type = IconButtonType;
